import axios from "axios";

export const isHotelname = (searcharray, hotelname) => {
    let place = searcharray.find(item => item.place.name.toUpperCase() === hotelname.toUpperCase());

    return place;
}

// Inoffizieller Endpunkt der halalbooking-Webseite (die offizielle API hat keine Ortsvorschläge).
// Seit 2026 liefert er HTML (Turbo-Frame) statt JSON, daher wird hier wieder das alte Format
// {results: [{id, name, "search-type", "properties-count"}]} gebaut.
const DESTINATIONS_URL = "https://halalbooking.com/destinations/search";

const fetchDestinations = async (search, locale) => {
    let res = await axios.get(DESTINATIONS_URL, {
        params: {locale: locale.toLowerCase(), term: search},
        responseType: "text"
    });

    let doc = new DOMParser().parseFromString(res.data, "text/html");

    // "fl_page" sind Landingpages von halalbooking ("Beliebte Suchanfragen"), keine Orte
    return Array.from(doc.querySelectorAll("li[data-search-type]"))
        .filter(li => li.dataset.searchType !== "fl_page")
        .map(li => ({
            id: parseInt(li.dataset.destinationId),
            name: li.dataset.locationName,
            "search-type": li.dataset.searchType,
            "properties-count": li.dataset.propertiesCount
        }));
}

const findSame = (results, item) => {
    return results.find(r => r.id === item.id && r["search-type"] === item["search-type"]);
}

export const halalsearch = async (search) => {
    let lang = (localStorage.getItem('lang') || "de").toLowerCase();

    try {
        // Für die Suche über die API wird der englische Name benötigt ("name-en")
        let [results, resultsEN] = await Promise.all([
            fetchDestinations(search, lang),
            lang === "en" ? null : fetchDestinations(search, "en")
        ]);

        results.forEach(item => {
            let en = findSame(resultsEN || results, item);
            item["name-en"] = en ? en.name : item.name;
        });

        return {results: results};
    } catch (e) {
        return {results: []};
    }
}

const halalsearchLang = async (search, locale) => {
    try {
        return {results: await fetchDestinations(search, locale)};
    } catch (e) {
        return {results: []};
    }
}

export const halalsearchTR = async (search) => {
    return halalsearchLang(search, "tr");
}


export const halalsearchDE = async (search) => {
    return halalsearchLang(search, "de");
}

export const halalsearchEN = async (search) => {
    return halalsearchLang(search, "en");
}
